import React from 'react';
import styled from 'styled-components';
import {
  CheckCircleRounded as ApprovedIcon,
  RemoveCircleRounded as BlockedIcon,
  ErrorRounded as RejectedIcon,
  WatchLaterRounded as PendingIcon,
  PregnantWomanRounded as PregnancyIcon,
  BeachAccessRounded as VacationIcon,
  SupervisorAccountRounded as FamilyIcon,
  WorkOffRounded as GeneralLeaveIcon
} from '@material-ui/icons';

import { LeaveState } from 'domain-types';

const ApprovedStyled = styled(ApprovedIcon)`
  color: ${p => p.theme.palette.success.light};
`;
const ApprovedFiledStyled = styled(ApprovedIcon)`
  color: ${p => p.theme.palette.text.disabled};
`;
const RejectedStyled = styled(RejectedIcon)`
  color: ${p => p.theme.palette.error.light};
`;
const PendingStyled = styled(PendingIcon)`
  color: ${p => p.theme.palette.text.disabled};
`;
const BlockedStyled = styled(BlockedIcon)`
  color: ${p => p.theme.palette.text.disabled};
`;

export const getLeaveTypeIcon = (type: string) => {
  switch (type) {
    case 'family':
      return <FamilyIcon />;
    case 'pregnancy':
      return <PregnancyIcon />;
    case 'vacation':
      return <VacationIcon />;
    case 'bereavement':
    case 'military':
    case 'religious':
    case 'sick':
    default:
      return <GeneralLeaveIcon />;
  }
};

export const getLeaveIcon = (state: LeaveState) => {
  switch (state) {
    case 'rejected':
      return <RejectedStyled />;
    case 'requested':
      return <PendingStyled />;
    case 'approved':
      return <ApprovedStyled />;
    case 'filed':
      return <ApprovedFiledStyled />;
    default:
      return <BlockedStyled />;
  }
};
